import React, { Component } from 'react';
import { Nav, Tab } from 'react-bootstrap';
import ServicesList from '../SpaServices/ServicesList';
import ServiceAvailabilityTab from '../SpaServices/ServiceAvailabilityTab';
import ServiceBenefitsTab from '../SpaServices/ServiceBenefitsTab';
import MediaQuery from 'react-responsive';
import FilterFooter from '../Filter/FilterFooter';

class FilterMobileTab extends Component {
    constructor(props) {
        super(props);
    }


    onTabClick=(selectedKey)=> {
     const { updateSelectedKey } = this.props;
        window.scrollTo(0, 0);
        if(updateSelectedKey) {
          updateSelectedKey(selectedKey);
        }
    }


    render() {
        const { selectedKey } = this.props;
        return (
            <div className={`mobile-filter-container  ${selectedKey == 'options' ? 'hide' : 'visible'}`}>
                <Tab.Container id="left-tabs-example" activeKey={selectedKey} defaultActiveKey={selectedKey} onSelect={this.onTabClick}>
                    <Nav className="mob-filter-nav font-size-p2 gotham-xn-medium" defaultActiveKey="services">
                        <Nav.Item className={`col-sm-4 col-xs-4 ${selectedKey === 'services' ? 'active-item' : ''}`}>
                            <Nav.Link eventKey="services">Services </Nav.Link>
                        </Nav.Item>
                        <Nav.Item className={`col-sm-4 col-xs-4 ${selectedKey === 'availability' ? 'active-item' : ''}`}>
                            <Nav.Link eventKey="availability"  >Availability </Nav.Link>
                        </Nav.Item>
                        <Nav.Item className={`col-sm-4 col-xs-4 ${selectedKey === 'benefits' ? 'active-item' : ''}`}>
                            <Nav.Link eventKey="benefits">Benefits</Nav.Link>
                        </Nav.Item>
                    </Nav>
                    <Tab.Content className='mobile-filter-tab-content'>
                        <Tab.Pane eventKey="services">
                            <ServicesList {...this.props} isMobileView={true}></ServicesList>
                        </Tab.Pane>
                        <Tab.Pane eventKey="availability">
                            <ServiceAvailabilityTab {...this.props} isMobileView={true}></ServiceAvailabilityTab>
                        </Tab.Pane>
                        <Tab.Pane eventKey="benefits">
                            <ServiceBenefitsTab onBenefitSelect={this.props.onBenefitSelect} isMobileView={true} {...this.props}></ServiceBenefitsTab>
                        </Tab.Pane>
                    </Tab.Content>
                </Tab.Container>
                <MediaQuery maxWidth={576}>
                    <FilterFooter hideReset={this.props.hideReset} resetFilter={this.props.resetFilter} selectedKey={selectedKey} onTabClick={this.onTabClick} isServicesLoading={this.props.services.isServicesLoading} actions={this.props.actions} services={this.props.services} onFilterButtonClick={this.props.onFilterButtonClick} />
                </MediaQuery>
            </div>
        );
    }
}



export default FilterMobileTab;